<template>
  <div class="flex flex-col">
    <el-card class="box-card  min-h-screen">
      <div class="m-auto  text-center text-3xl">
        案例列表
      </div>
      <div class="flex flex-row-reverse">
        <el-button type="primary" @click="goAddCase">添加案例 </el-button>
      </div>
      <div class=" mt-6">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column fixed prop="date" label="静图" width="150">
            <template slot-scope="scope">
              <img
                @click="handleClick(scope.row)"
                width="40px"
                height="40px"
                :src="scope.row.case_img ? scope.row.case_img : shengluetu"
                alt=""
                srcset=""
              />
            </template>
          </el-table-column>

          <el-table-column fixed prop="date" label="动图" width="150">
            <template slot-scope="scope">
              <img
                @click="handleClick2(scope.row)"
                width="40px"
                height="40px"
                :src="scope.row.case_img2 ? scope.row.case_img2 : shengluetu"
                alt=""
                srcset=""
              />
            </template>
          </el-table-column>
          <el-table-column fixed prop="date" label="体验二维码" width="150">
            <template slot-scope="scope">
              <img
                @click="handleClick3(scope.row)"
                width="40px"
                height="40px"
                :src="scope.row.case_img3 ? scope.row.case_img3  : shengluetu"
                alt=""
                srcset=""
              />
            </template>
          </el-table-column>
          <el-table-column fixed prop="date" label="pc官网头图" width="150">
            <template slot-scope="scope">
              <img
                @click="handleClick4(scope.row)"
                width="40px"
                height="40px"
                :src="scope.row.toutu ? scope.row.toutu  : shengluetu"
                alt=""
                srcset=""
              />
            </template>
          </el-table-column>
          <el-table-column fixed prop="date" label="pc官网长图" width="150">
            <template slot-scope="scope">
              <img
                @click="handleClick5(scope.row)"
                width="40px"
                height="40px"
                :src="scope.row.gwimages ? scope.row.gwimages : shengluetu"
                alt=""
                srcset=""
              />
            </template>
          </el-table-column>
          <el-table-column prop="case_title" label="案例标题" width="180">
          </el-table-column>
          <el-table-column prop="case_type" label="案例分类" width="120">
          </el-table-column>
          <el-table-column prop="webExplain" show-overflow-tooltip label="网站说明" width="120">
          </el-table-column>
          <el-table-column prop="hangyeCate" label="行业类型" width="120">
          </el-table-column>
          <el-table-column prop="projectContext" show-overflow-tooltip label="项目背景" width="120">
          </el-table-column>

          <el-table-column prop="add_time" label="发布时间" width="180">
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="deleteSlideshow(scope.row)"
                >删除</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="updateCase(scope.row)"
                >编辑</el-button
              >
            </template>

          </el-table-column>
        </el-table>
        <el-pagination class="mt-6"

          @current-change="handleCurrentChange"
          :current-page.sync="pageQuantity"
                       background
                       :page-size="pageCount"
          layout="total, prev, pager, next"
          :total="pagesCount">
        </el-pagination>




      </div>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <img :src="imgUrl" alt="" srcset="" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import shengluetu from '../../assets/img/shengluetu.png';
export default {
  data() {
    return {
      dialogVisible: false,
      imgUrl: "",
      tableData: [],
      case_imgList: [],
      pageQuantity:1,
      pageCount:6,
      pagesCount:'',
      shengluetu:shengluetu



    };
  },
  mounted() {
    this.getCaseList(this.pageQuantity,this.pageCount);

  },
  methods: {

    updateCase(row){

    //  this.$router.push({path:`/updateCase?case_id=${row.case_id}`})   //$route.params.id
    this.$router.push({path:'/updateCase',query:{case_id : row.case_id}})
    },
    handleCurrentChange(val) {
      this.getCaseList(val,this.pageCount)
    },
    //获取数据   第几页  每页几条
    getCaseList(pageQuantity,pageCount) {
      axios.get(`/caseIndex?pageQuantity=${pageQuantity}&pageCount=${pageCount}`).then(({ data }) => {

        this.tableData = data.data;
        this.pagesCount = data.pagesCount
      });
    },
    handleClick(row) {
      this.imgUrl =  row.case_img;
      this.dialogVisible = true;
    },
    handleClick2(row) {
      this.imgUrl =  row.case_img2;
      this.dialogVisible = true;
    },
    handleClick3(row) {
      this.imgUrl =  row.case_img3;
      this.dialogVisible = true;
    },
    handleClick4(row) {
      this.imgUrl =  row.toutu;
      this.dialogVisible = true;
    },
    handleClick5(row) {
      this.imgUrl =  row.gwimages;
      this.dialogVisible = true;
    },
    goAddCase() {
      this.$router.push("/addCase");
    },
    updateSlideshow() {
      this.$router.push("/updateNews");
    },
    handleClose(done) {
      this.dialogVisible = false;
    },

    deleteSlideshow(row) {

      this.$confirm("此操作将永久删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios.delete("/caseDelete_id/" + row.case_id).then(({ data }) => {
            if (data.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getCaseList(this.pageQuantity,this.pageCount);

            }

          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },


};
</script>



// WEBPACK FOOTER //
// src/views/case/caseList.vue